import {
  FETCH_COLORS_REQUEST,
  FETCH_COLORS_SUCCESS,
  FETCH_COLORS_FAILURE,
  CREATE_COLOR,
  UPDATE_COLOR,
  DELETE_COLOR,
} from '../../types/color/colorTypes';

const initialState = {
  colors: [],
  loading: false,
  error: null,
};

const colorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COLORS_REQUEST:
      return { ...state, loading: true };

    case FETCH_COLORS_SUCCESS:
      return { ...state, loading: false, colors: action.payload };

    case FETCH_COLORS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    
    case CREATE_COLOR:
  return {
    ...state,
    colors: [...state.colors, action.payload],
  };

    case DELETE_COLOR:
      return {
        ...state,
        colors: state.colors.filter((d) => d.id !== action.payload),
      };

    case UPDATE_COLOR:
      return {
        ...state,
        colors: state.colors.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default colorReducer;
